<div class="lum-form-placeholder" fxLayout="row" fxLayoutAlign="center center">
  <p class="lum-body-1 lum-no-margin">{{ placeholder }}</p>
</div>
